import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export function CTAButton({
  text,
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className={`inline-block bg-gradient-to-r from-[#F2B705] to-[#E5A800] text-carbon font-bold rounded-xl px-8 py-4 text-center hover:brightness-110 transition-all tracking-wide ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(242,183,5,0)', '0px 0px 15px rgba(242,183,5,0.3)', '0px 0px 0px rgba(242,183,5,0)']
  }} transition={{
    duration: 3,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-1">
      {text}
    </motion.a>;
}